.Page {
  align-items: center;
  background: var(--rv-bg-app-subtle);
  display: flex;
  inset: 0;
  justify-content: center;
  position: fixed;
}

.Spinner {
  animation: end-user-spin var(--rv-dur-slow) linear infinite;
  color: var(--rv-fg-3);
  height: var(--icon-size-lg);
  width: var(--icon-size-lg);
}

@keyframes end-user-spin {
  to {
    transform: rotate(360deg);
  }
}

@media (prefers-reduced-motion: reduce) {
  .Spinner {
    animation: none;
  }
}
